import React, { Component } from 'react';
import { connect } from 'react-redux';
import {mobileMenuToggle, mobileMenuClose} from '../fm/reducers/screen'
import Link from '../fm/lib/Link'
import {realPath} from '../fm/lib/util'
import HeaderAdminMenu from '../fm/admin/HeaderAdminMenu'
import {WEBSITE_NAME} from '../config'
import {find} from '../fm/reducers/page'

class Header extends Component {
	componentWillMount() {
		this.checkMenu(this.props)
	}
	componentWillReceiveProps(nextProps) {
		this.checkMenu(nextProps)
	}
	checkMenu(props) {
		const {menu, find} = props

		if(!menu) find('menu', {collection: 'menu', query: {type:'main'}})
	}
	onMobile() {
		this.props.mobileMenuToggle()
	}
	hideMobile(e) {
		this.props.mobileMenuClose()
	}

	renderLink = (item, i, level=0) => {
		return (
			<li key={i}>
      			<Link to={item.p}>
      				{level===0 &&
      				<svg className='shadow' viewBox='0 0 170 41' preserveAspectRatio="none">
      					<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" 
      						stroke="#0a63bd" strokeWidth="4">
    					<path d="M1507 403 c-5 -4 -336 -10 -735 -13 l-727 -5 -13 -27 c-19 -40 -36 -253 -25 -308 l9 -45 837 -3 c767 -2 838 -1 844 14 3 9 2 78 -4 153 -11 139 -30 214 -60 225 -29 11 -118 18 -126 9z"/>
    					</g>
  					</svg>
      				}
      				<div>{item.title}</div>
      			</Link>
      			{item.items && 
      				<ul className='menu'>
      					{item.items.map((item,i) => this.renderLink(item, i, level+1))}
      				</ul>
      			}
			</li>
		)
	}
	/*
	menuItem(label, mq, scroll) {
		return (
				<div style={{display:'inline-block',position:'relative',
					height:menuStyle[mq]['height'],cursor:'pointer',marginLeft:'1px',
					transition: 'height .5s ease-in-out'
				}}>
      				<SvgIcon className='shadow' viewBox='0 0 170 41' preserveAspectRatio="none" 
      					hoverColor='#43a5f8' color='#257aca' 
      					style={{display:'block',margin:0,height:41,width:'100%',position:'absolute',top:0,left:0}}>
      					<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000) "  
      					stroke="#0a63bd" strokeWidth="4">
    					<path d="M1507 403 c-5 -4 -336 -10 -735 -13 l-727 -5 -13 -27 c-19 -40 -36 -253 -25 -308 l9 -45 837 -3 c767 -2 838 -1 844 14 3 9 2 78 -4 153 -11 139 -30 214 -60 225 -29 11 -118 18 -126 9z"/>
    					</g>
  					</SvgIcon>
  					<span style={{
  						position:'relative',
  						display:'inline-block',
  						padding:'0 12px',
  						height:menuStyle[mq]['height'], 
  						fontSize:menuStyle[mq]['fontSize']+'px', 
  						lineHeight:menuStyle[mq]['height'] + 'px', 
  						transition: 'all .5s ease-in-out',
  						letterSpacing:'1px', 
  						pointerEvents:'none',
  						color:'#ffffff'}}>{label}</span>
  				</div>
		);
	}
	*/
  	render() {
  		const {menu, mobileMenu} = this.props

		return (
			<header role='banner' id='header'>
				<div className='header-in'>
      			<Link id='logo' className='logo' to='/'><img src={realPath('/upload/sigla-lacrima-a.png')} alt={WEBSITE_NAME}/></Link>
      			
      			{menu && 
      			<ul className={'main-menu '+(mobileMenu?'open':'')}>
      				{menu.items.map((item,i) => this.renderLink(item, i))}
      			</ul>
      			}
      			
      			<a id='mobile-menu' className={mobileMenu?'open':''} 
      				onClick={this.onMobile.bind(this)}><i className='fa fa-bars'/></a>

				</div>
				
      			<HeaderAdminMenu/>
			</header>
    	);
	}
}

function mapStateToProps(state) {
	const lang = state.page.lang
	
	return {
    	//w: state.screen.w,
    	//mq: state.screen.mq,
    	lang,
        mobileMenu: state.screen.mobileMenu,
		menu: (state.page.menu && state.page.menu.data)?state.page['menu'].data[0]:null,
		node: (state.page[state.page.location] && state.page[state.page.location].data && state.page[state.page.location].data.length>0)?state.page[state.page.location].data[0]:null
	}
}
export default connect(mapStateToProps, {find, mobileMenuToggle, mobileMenuClose})(Header);




// WEBPACK FOOTER //
// ./src/components/Header.js